import { render, staticRenderFns } from "./OverviewIcon.vue?vue&type=template&id=0b06eee0"
import script from "./OverviewIcon.vue?vue&type=script&lang=js"
export * from "./OverviewIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports